import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { transactionType } from '@/optionSets';
import { TransactionType } from '@/database/baseTypes';

interface TypeAutocompleteProps {
  value?: TransactionType;
  error: boolean;
  helperText?: string;
  inputRef?: React.Ref<any>;
  onSelect: (type?: TransactionType) => void;
  sx?: any; // Add sx prop
}

const pinkFocusStyles = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ff00bf',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#ff00bf',
  },
};

const TypeAutocomplete = ({
  value,
  error,
  helperText,
  inputRef,
  onSelect,
  sx,
}: TypeAutocompleteProps) => {
  return (
    <Autocomplete
      options={transactionType}
      noOptionsText='No types'
      onChange={(_, newValue) => onSelect(newValue?.value ?? undefined)}
      value={transactionType.find((option) => option.value === value) ?? null}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          label='Type'
          fullWidth
          error={error}
          helperText={helperText}
          required
          sx={pinkFocusStyles}
        />
      )}
    />
  );
};

export default TypeAutocomplete;
